
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class FreightDialog extends Serenity.EntityDialog<FreightRow, any> {
        protected getFormKey() { return FreightForm.formKey; }
        protected getIdProperty() { return FreightRow.idProperty; }
        protected getLocalTextPrefix() { return FreightRow.localTextPrefix; }
        protected getNameProperty() { return FreightRow.nameProperty; }
        protected getService() { return FreightService.baseUrl; }
        protected getDeletePermission() { return FreightRow.deletePermission; }
        protected getInsertPermission() { return FreightRow.insertPermission; }
        protected getUpdatePermission() { return FreightRow.updatePermission; }

        protected form = new FreightForm(this.idPrefix);

    }
}